import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
export default {
  name: "lifestyle-recommend",
  data: function data() {
    return {
      recommendPool: 1,
      // 推荐池
      searchForm: {
        pn: 1,
        ps: 500,
        order: "recommend",
        status: 1,
        subjectStatus: 2,
        isRecommend: 1
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      recommendPoolTotal1: 0,
      // 推荐池1总数
      recommendPoolTotal2: 0 // 推荐池2总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getLifestyleRecommendPool1();
            _this.getLifestyleRecommendPool2('init');
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getLifestyleRecommendPool1: function getLifestyleRecommendPool1() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getLifestyleRecommendPool1({
                pageNum: 1,
                pageSize: 500
              });
            case 1:
              res = _context2.v;
              res.data.content.forEach(function (item) {
                item.recommendTime = dayjs(item.recommendTime * 1000).format("YYYY-MM-DD HH:mm:ss");
                item.update = dayjs(item.update * 1000).format("YYYY-MM-DD HH:mm:ss");
                item.create = dayjs(item.create * 1000).format("YYYY-MM-DD HH:mm:ss");
              });
              _this2.tableData = res.data.content;
              _this2.recommendPoolTotal1 = res.data.totalSize;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getLifestyleRecommendPool2: function getLifestyleRecommendPool2(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getLifestyleRecommendPool2({
                pageNum: 1,
                pageSize: 500
              });
            case 1:
              res = _context3.v;
              res.data.content.forEach(function (item) {
                item.recommendTime = dayjs(item.recommendTime * 1000).format("YYYY-MM-DD HH:mm:ss");
                item.update = dayjs(item.update * 1000).format("YYYY-MM-DD HH:mm:ss");
              });
              if (type === 'init') {
                _this3.recommendPoolTotal2 = res.data.totalSize;
              } else {
                _this3.tableData = res.data.content;
                _this3.recommendPoolTotal2 = res.data.totalSize;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (_this4.recommendPool == 1) {
                _this4.getLifestyleRecommendPool1();
              } else {
                _this4.getLifestyleRecommendPool2();
              }
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 推荐|取消推荐
    recommend: function recommend(row) {
      var _this5 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.recommendLifestyle({
                id: row.id,
                type: row.isRecommend == 1 ? 0 : 1
              });
            case 1:
              _this5.$message.success("操作成功");
              _this5.getData();

              // 操作上报
              _this5.$operationLog.push({
                code: row.isRecommend == 1 ? 'unrecommend' : 'recommend',
                userId: row.userId,
                operationType: "lifestyle",
                detailBatchNo: row.id
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    }
  }
};